<template>
  <div>
    <v-card class="pa-0" v-resize="getTreeHight">
      <v-card-title class="pa-2 pr-6">
        <v-row no-gutters>
          <v-col cols="6" xs="6" sm="4" lg="3" md="4">
            {{ $t('message.hse.hseSystem') }}
          </v-col>
          <v-col cols="6" xs="6" sm="4" lg="3">
          <v-text-field hide-details outlined dense append-icon="search" :placeholder="$t('message.common.search')" v-model="search"
            @keyup.enter="sharepointSearch(search)" @click:append="sharepointSearch(search)"></v-text-field>
          </v-col>
          <v-spacer></v-spacer>
          <v-col cols="6" xs="6" sm="4" lg="3" class="text-right">
            <v-btn color="primary" class="text-right" @click="documentDialog">
              <v-icon>add_circle_outline</v-icon>
              {{ $t('message.hse.uploadDocument') }}
            </v-btn>
          </v-col>
        </v-row>
      </v-card-title>
      <v-divider></v-divider>
      <v-card-text class="pa-1">
        <v-row no-gutters>
          <v-col cols="12" sm="6" md="5" lg="2">
            <v-row no-gutters>
              <v-col cols="6">
                <v-tooltip bottom>
                  <template v-slot:activator="{ on }">
                    <v-btn fab small text color="dark" v-on="on" @click="openDialogHandler">
                      <v-icon>create_new_folder</v-icon>
                    </v-btn>
                  </template>
                  <span>{{ $t('message.hse.createNew') }}</span>
                </v-tooltip>
                <v-tooltip bottom v-if="active.length > 0">
                  <template v-slot:activator="{ on }">
                    <v-btn fab small text color="info" v-on="on" @click="editFolderHandler" v-if="!hideTreeViewActions">
                      <v-icon>mdi-message-draw</v-icon>
                    </v-btn>
                  </template>
                  <span>{{ $t('message.hse.editName') }}</span>
                </v-tooltip>
                <v-tooltip bottom v-if="active.length > 0">
                  <template v-slot:activator="{ on }">
                    <v-btn fab small text color="error" v-on="on" @click="deleteHandler(active[0].id)" v-if="!hideTreeViewActions">
                      <v-icon>mdi-folder-remove</v-icon>
                    </v-btn>
                  </template>
                  <span>{{ $t('message.hse.deleteFolder') }}</span>
                </v-tooltip>
              </v-col>
            </v-row>
            <v-divider></v-divider>
            <template v-if="loadingBase">
              <div class="subtitle-1 mt-1">{{ $t('message.hse.gettingFolders') }}</div>
              <v-progress-linear rounded height="6" indeterminate color="primary"></v-progress-linear>
            </template>
            <v-treeview dense shaped hoverable class="tree--document" :style="{ 'maxHeight': treeHight, overflow: 'scroll' }" v-show="!hideTreeViewActions"
              v-model="allNodesList" @update:active="getFilesForFolder" :active.sync="active" :load-children="getChildrenItems"
              :open.sync="open" return-object :items="foldersList" activatable>
              <template v-slot:prepend="{ item, open }">
                <v-icon>
                  {{ open ? 'mdi-folder-open' : 'mdi-folder' }}
                </v-icon>
              </template>
              <template v-slot:label="{ item }">
                <v-hover v-slot:default="{ hover }">
                  <div class="text-truncate">
                    <v-icon v-if="hover" small @click.stop="navigateToOD(item.webUrl)">launch</v-icon>
                    {{ item.name }}
                  </div>
                </v-hover>
              </template>
            </v-treeview>
            <template v-if="hideTreeViewActions">
            <v-card :style="{ 'maxHeight': treeHight, overflow: 'scroll' }">
              <v-subheader>Search Results : Found {{searchResultArray.length}}</v-subheader>
              <v-simple-table dense v-if="searchResultArray.length > 0" class="bordered--table">
                <template v-slot:default>
                  <thead>
                    <tr>
                      <th class="text-left">{{$t('message.deviations.title')}}</th>
                      <th class="text-left">{{$t('message.tickets.actions')}}</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="(item, i) in searchResultArray" :key="i">
                      <td>
                        <v-icon :size="32" :color="item.isdocument ? mimeTypeOfDocument(item.mimetype).color : 'grey'">
                          {{ item.isdocument ? mimeTypeOfDocument(item.mimetype).icon : 'mdi-folder' }}
                        </v-icon>
                        {{item.title}}
                      </td>
                      <td>
                        <v-icon class="pr-2" @click.stop="navigateToOD(item.weburl)">launch</v-icon>
                        <v-icon v-if="item.isdocument" @click.stop="navigateToOD(item.path)">mdi-cloud-download</v-icon>
                      </td>
                    </tr>
                  </tbody>
                </template>
              </v-simple-table>
            </v-card>
            </template>
            <v-alert color="info" dark icon="mdi-onedrive" border="left" prominent outlined v-if="foldersList.length <= 0 && !loadingBase">
              {{ $t('message.hse.noFolders') }}
            </v-alert>
          </v-col>
          <v-col cols="12" sm="6" md="7" lg="10" class="pa-1 pt-0" v-if="!hideTreeViewActions">
            <v-progress-linear rounded height="6" v-if="loading" indeterminate color="primary"></v-progress-linear>
            <template v-if="documentsLoading">
              <v-card class="elevation-7">
                <v-skeleton-loader class="mx-auto" type="table"></v-skeleton-loader>
              </v-card>
            </template>
            <v-simple-table dense class="bordered--table" v-if="listOfActiveFiles.length > 0">
              <template v-slot:default>
                <thead>
                  <tr>
                    <th class="text-left" v-for="(prop, index) in listOfProperties" :key="index">{{ prop.title }}</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(file, i) in listOfActiveFiles" :key="file.id">
                    <td width="5%">
                      <v-speed-dial :v-model="`fab_${i}`" :right="true" direction="right" transition="slide-y-reverse-transition">
                        <template v-slot:activator>
                          <v-btn size="32" text icon  :v-model="`fab_${i}`">
                            <v-icon :size="32" :color="mimeTypeOfDocument(file.mimetype).color">{{ mimeTypeOfDocument(file.mimetype).icon }}</v-icon>
                          </v-btn>
                        </template>
                        <v-btn  @click="navigateToOD(file.weburl)" fab small>
                          <v-scale-transition>
                            <v-tooltip bottom>
                              <template v-slot:activator="{ on }">
                                <v-icon v-on="on">mdi-open-in-new</v-icon>
                              </template>
                              <span>{{$t('message.hse.openNewTab')}}</span>
                            </v-tooltip>
                          </v-scale-transition>
                        </v-btn>
                        <v-btn  fab  small color="primary" @click="editMetaInDocument(file)">
                          <v-scale-transition>
                            <v-tooltip bottom>
                              <template v-slot:activator="{ on }">
                                <v-icon v-on="on">colorize</v-icon>
                              </template>
                              <span>{{$t('message.hse.editMeta')}}</span>
                            </v-tooltip>
                          </v-scale-transition>
                        </v-btn>
                        <v-btn fab small color="info" @click="downloadHandler(file.id)">
                          <v-scale-transition>
                            <v-tooltip bottom>
                              <template v-slot:activator="{ on }">
                                <v-icon v-on="on">mdi-cloud-download</v-icon>
                              </template>
                              <span>{{$t('message.order.download')}}</span>
                            </v-tooltip>
                          </v-scale-transition>
                        </v-btn>
                        <v-btn fab small color="error" @click="deleteHandler(file.id)">
                          <v-scale-transition>
                            <v-tooltip bottom>
                              <template v-slot:activator="{ on }">
                                <v-icon v-on="on">mdi-delete-circle</v-icon>
                              </template>
                              <span>{{$t('message.common.delete')}}</span>
                            </v-tooltip>
                          </v-scale-transition>
                        </v-btn>
                      </v-speed-dial>
                    </td>
                    <td v-for="(prop, index) in file.properties" :key="index">
                      <template v-if="prop.value && prop.value.lookupvalue">
                        {{ prop.value.lookupvalue }}
                      </template>
                      <template v-else-if="dateFieldsForConversion.find(x => x === prop.name)">
                        {{ prop.value | dateFormat }}
                      </template>
                      <template v-else>
                        {{ prop.value }}
                      </template>
                    </td>
                  </tr>
                </tbody>
              </template>
            </v-simple-table>
            <v-alert color="info" dark icon="mdi-onedrive" border="left" prominent outlined v-if="listOfActiveFiles.length <= 0 && !documentsLoading">
              {{ $t('message.hse.noDocuments') }}
            </v-alert>
          </v-col>
       </v-row>
      </v-card-text>
    </v-card>
    <v-dialog v-model="folderDialog" width="600" persistent>
      <form-template :references.sync="folderFormReferences" :model="folderModel" ref="folderReference"></form-template>
    </v-dialog>
    <v-dialog v-model="uploadDocumentDialog" width="600" persistent>
      <form-template :references.sync="propertiesFormReference" :model="propertyModel.properties" ref="documentReference"></form-template>
    </v-dialog>
  </div>
</template>
<script>
import { mapState } from 'vuex'
import FormTemplate from '../../components/FormTemplate'
import DEFAULT_PROP from './prop_types.json'
export default {
  data () {
    return {
      open: ['public'],
      active: [],
      foldersList: [],
      MODULE_URL: 'sharepoint',
      listOfActiveFiles: [],
      loadingBase: false,
      documentsLoading: false,
      folderDialog: false,
      uploadDocumentDialog: false,
      documentFormloading: false,
      folderLoading: false,
      folderModel: {},
      propertyModel: {},
      loading: false,
      isShowAttachment: true,
      alreadyOpened: [],
      alreadyActive: [],
      allNodesList: [],
      term: '',
      childCount: 0,
      treeHight: 0,
      listOfProperties: [],
      dynamicFormFields: [],
      formProps: [],
      dateFieldsForConversion: [],
      fab: false,
      hideTreeViewActions: false,
      search: '',
      selectedNode: '',
      searchResultArray: []
    }
  },
  computed: {
    ...mapState(['FORM_TYPE']),
    actionItems () {
      return [{
        icon: '',
        click: ''
      }]
    },
    folderFormReferences () {
      return {
        title: this.folderModel.id ? this.$t('message.hse.editName') : this.$t('message.hse.createNew'),
        properties: [{
          model: 'name',
          ref: 'autoFocus',
          type: this.FORM_TYPE.TEXT,
          rules: this.$_requiredValidation,
          label: this.$t('message.hse.folderName'),
          class: 'xs12'
        }],
        buttons: [{
          name: 'action_handler',
          color: 'success',
          label: this.folderModel.id ? this.$t('message.common.update') : this.$t('message.common.save'),
          click: this.saveUpdateFolderHandler,
          loading: this.folderLoading,
          is_show: true
        }, {
          name: 'close',
          color: 'error',
          click: this.closeDialogHandler,
          label: this.$t('message.common.close'),
          is_show: true
        }]
      }
    },
    propertiesFormReference () {
      return {
        title: this.isShowAttachment ? this.$t('message.hse.upload') : this.$t('message.hse.updateMetaData'),
        properties: this.formProps,
        buttons: [{
          name: 'action_handler',
          color: 'success',
          label: this.isShowAttachment ? this.$t('message.hse.upload') : this.$t('message.common.update'),
          click: this.isShowAttachment ? this.uploadDocumentHandler : this.updateDocumentMeta,
          loading: this.documentFormloading,
          is_show: true
        }, {
          name: 'close',
          color: 'error',
          click: this.closeDocumentDialogHandler,
          label: this.$t('message.common.close'),
          is_show: true
        }]
      }
    }
  },
  components: {
    FormTemplate
  },
  watch: {
    search (val) {
      if (!val) {
        this.hideTreeViewActions = false
      }
    }
  },
  mounted () {
    let text = this.$t('message.common.deleteMsg')
    this.$eventBus.$on('deleteSuccess', (data) => {
      if (data === this.MODULE_URL) {
        this.$root.$emit('snackbar', { snackbar: true, color: 'success', text })
        this.$store.commit('hideDialog')
        this.getBaseFolders()
      }
    })
    this.getBaseFolders()
    // this.getSelectedFields()
    this.getTreeHight()
    if (!this.$formatter.isEmptyObject(this.$store.state.F_HSE_LIST)) {
      let data = this.$formatter.cloneVariable(this.$store.state.F_HSE_LIST)
      let { search } = data.filter
      this.search = search || ''
    }
  },
  methods: {
    // getSelectedFields () {
    //   this.$_executeApi('get', `${this.MODULE_URL}/get_selected_fields`)
    //     .then((response) => {
    //       let avaliableProps = response.data || []
    //       this.dynamicFormFields = this.$formatter.cloneVariable(avaliableProps)
    //       avaliableProps.unshift({ title: this.$t('message.product.type') })
    //       // avaliableProps.push({ title: this.$t('message.tickets.actions') })
    //       this.listOfProperties = avaliableProps
    //       this.prepareFieldsForProperties()
    //     })
    // },
    prepareFieldsForProperties () {
      let dynamicInputs = []
      this.dateFieldsForConversion = []
      for (let i = 0; i < this.dynamicFormFields.length; i++) {
        let field = this.dynamicFormFields[i]
        switch (field.type) {
          case DEFAULT_PROP.URL:
          case DEFAULT_PROP.TEXT:
          case DEFAULT_PROP.FILE:
          case DEFAULT_PROP.CURRENCY:
            dynamicInputs.push({ model: field.name, type: this.FORM_TYPE.TEXT, label: field.title, class: 'xs12' })
            break
          case DEFAULT_PROP.NUMBER:
          case DEFAULT_PROP.INTERGER:
            dynamicInputs.push({ model: field.name, type: this.FORM_TYPE.NUMBER, label: field.title, class: 'xs12' })
            break
          case DEFAULT_PROP.NOTE:
            dynamicInputs.push({ model: field.name, type: this.FORM_TYPE.TEXTAREA, label: field.title, class: 'xs12' })
            break
          case DEFAULT_PROP.BOOLEAN:
            dynamicInputs.push({ model: field.name, type: this.FORM_TYPE.CHECKBOX, label: field.title, class: 'xs12' })
            break
          case DEFAULT_PROP.CHOICE:
            dynamicInputs.push({ model: field.name, type: this.FORM_TYPE.AUTO_COMPLETE, items: field.choices, label: field.title, class: 'xs12' })
            break
          case DEFAULT_PROP.MULTICHOICE:
            dynamicInputs.push({ model: field.name, type: this.FORM_TYPE.AUTO_COMPLETE, items: field.choices, multiple: true, label: field.title, class: 'xs12' })
            break
          case DEFAULT_PROP.USER:
            dynamicInputs.push({ model: field.name, type: this.FORM_TYPE.AUTO_COMPLETE, items: field.users, select_value: 'id', select_text: 'name', label: field.title, class: 'xs12' })
            break
          case DEFAULT_PROP.DATETIME:
            this.dateFieldsForConversion.push(field.name)
            dynamicInputs.push({ model: field.name, type: this.FORM_TYPE.DATEPICKER, menu: `${field.name}_menu`, picker: `${field.name}_picker`, label: field.title, class: 'xs12', color: 'primary lighten-1' })
            this.$watch(`propertyModel.properties.${field.name}_picker`, (val) => {
              if (val) {
              // setTimeout(() => {
                this.propertyModel.properties[field.name] = this.$formatter.formatDate(val, 'YYYY-MM-DD', 'DD.MM.YYYY')
              // },100)
              }
            })
            break
          default:
            break
        }
      }
      this.formProps = dynamicInputs
    },
    // getBaseFolders () {
    //   this.loadingBase = true
    //   this.foldersList = []
    //   this.listOfActiveFiles = []
    //   this.childCount = 0
    //   this.$_executeApi('get', `${this.MODULE_URL}/get_base_folder`)
    //     .then((response) => {
    //       let result = response.data
    //       this.foldersList.push({ id: result.id, name: result.name, children: [], webUrl: result.weburl })
    //     })
    //     .finally(() => {
    //       this.alreadyOpened = this.$formatter.cloneVariable(this.open)
    //       this.alreadyActive = this.$formatter.cloneVariable(this.active)
    //       this.loadingBase = false
    //       this.open = this.alreadyOpened.map(x => x)
    //       this.active = []
    //     })
    // },
    getBaseFolders () {
      this.loadingBase = true
      this.foldersList = []
      this.listOfActiveFiles = []
      this.childCount = 0
      this.$_executeApi('get', `${this.MODULE_URL}/get_base_folder_and_fields`)
        .then((response) => {
          let folder = response.data.basefolder
          this.foldersList.push({ id: folder.id, name: folder.name, children: [], webUrl: folder.weburl })
          let avaliableProps = response.data.fields || []
          this.dynamicFormFields = this.$formatter.cloneVariable(avaliableProps)
          try { // added by vinoth - got translation related console issue
            avaliableProps.unshift({ title: this.$t('message.product.type') })
          } catch (error) {}
          // avaliableProps.push({ title: this.$t('message.tickets.actions') })
          this.listOfProperties = avaliableProps
          this.prepareFieldsForProperties()
        })
        .finally(() => {
          this.alreadyOpened = this.$formatter.cloneVariable(this.open)
          this.alreadyActive = this.$formatter.cloneVariable(this.active)
          this.loadingBase = false
          this.open = this.alreadyOpened.map(x => x)
          this.active = []
        })
    },
    getChildrenItems (item) {
      return this.$_executeApi('get', `${this.MODULE_URL}/get_children_folders/${item.id}`)
        .then((response) => {
          let children = response.data
          if (this.$formatter.isArrayHasData(children)) {
            for (let i = 0; i < children.length; i++) {
              item.children.push({ id: children[i].id, name: children[i].name, webUrl: children[i].weburl, children: children[i].childcount > 0 ? [] : undefined })
              if (this.$formatter.isArrayHasData(this.alreadyOpened)) {
                this.open.push(item)
              }
            }
            this.childCount++
          }
        })
        .finally(() => {
          if (this.$formatter.isArrayHasData(this.alreadyOpened)) {
            this.alreadyOpened.forEach(node => {
              this.open.push(...item.children.filter(x => x.id === node.id))
            })
            if (this.$formatter.isArrayHasData(this.alreadyActive)) {
              if (this.childCount === this.alreadyOpened.length) {
                this.active = this.alreadyActive.map(x => x)
                this.alreadyOpened = []
              }
            }
          }
        })
    },
    getFilesForFolder () {
      setTimeout(() => {
        this.listOfActiveFiles = []
        this.selectedNode = this.active[0].webUrl
        if (this.active && this.active[0]) this.getSelectedNodeFiles(this.active[0].id)
      })
    },
    getSelectedNodeFiles (id) {
      this.documentsLoading = true
      this.$_executeApi('get', `${this.MODULE_URL}/get_children_documents/${id}`)
        .then((response) => {
          let files = (response && response.data) ? response.data : []
          this.listOfActiveFiles = files
        })
        .finally(() => {
          this.documentsLoading = false
        })
    },
    searchForFolderHandler () {
      this.loadingBase = true
      let activeFolder = (this.active && this.active[0]) ? this.active[0].id : null
      this.$_executeApi('get', `${this.MODULE_URL}/search?term=${this.term}&folder_id=${activeFolder}`)
        .then((response) => {
          let result = response.data
          this.foldersList.push({ id: result.id, name: result.name, children: [], webUrl: result.weburl })
        })
        .finally(() => {
          this.alreadyOpened = this.$formatter.cloneVariable(this.open)
          this.loadingBase = false
          this.active = []
          this.open = this.alreadyOpened.map(x => x)
        })
    },
    openDialogHandler () {
      this.folderDialog = true
      let selected = this.active
      this.folderModel = { id: null, parent_id: (selected && selected[0]) ? selected[0].id : null }
      this.autoFocusField()
    },
    editFolderHandler () {
      let { id, name } = this.active ? this.active[0] : { id: 0, name: null }
      this.folderModel = { id, name }
      this.folderDialog = true
      this.autoFocusField()
    },
    saveUpdateFolderHandler () {
      if (this.$refs.folderReference.$refs.validateForm.validate()) {
        this.folderLoading = true
        let model = this.folderModel
        let url = model.id ? 'rename' : 'create_folder'
        let method = model.id ? 'put' : 'post'
        let text = model.id ? this.$t('message.common.updatedSuccess') : this.$t('message.common.addedSucess')
        this.$_executeApi(method, `${this.MODULE_URL}/${url}`, model)
          .then((response) => {
            this.$root.$emit('snackbar', { snackbar: true, color: 'success', text: text })
          })
          .finally(() => {
            this.folderLoading = false
            this.closeDialogHandler()
            this.foldersList = []
            this.getBaseFolders()
          })
      } else this.$root.$emit('snackbar', { snackbar: true, color: 'error', text: this.$t('message.common.validationIssue') })
    },
    closeDialogHandler () {
      this.folderDialog = false
      this.$refs.folderReference.$refs.validateForm.reset()
    },
    downloadHandler (id) {
      this.loading = true
      this.$_executeApi('get', `${this.MODULE_URL}/download/${id}`)
        .then((response) => {
          this.loading = false
          window.open(`${process.env.VUE_APP_URL}file/download?fileName=${response.data}`, '_blank')
        })
    },
    documentDialog () {
      this.isShowAttachment = true
      this.uploadDocumentDialog = true
      let attachmentRefIndex = this.formProps.findIndex(x => x.model === 'files')
      this.propertyModel = { properties: {} }
      if (attachmentRefIndex < 0) {
        this.formProps.push({
          model: 'files',
          type: this.FORM_TYPE.FILES,
          is_show: this.isShowAttachment,
          multiple: true,
          rules: this.$_multiSelectValidation,
          label: this.$t('message.hse.files'),
          class: 'lg12'
        })
      }
    },
    uploadDocumentHandler () {
      if (this.$refs.documentReference.$refs.validateForm.validate()) {
        this.documentFormloading = true
        let parentId = (this.active && this.active[0]) ? this.active[0].id : null
        let props = this.propertyModel.properties
        let transformData = { date: { list: this.dateFieldsForConversion, from: 'DD.MM.YYYY', to: 'MM.DD.YYYY' } }
        let model = this.$_formatModel(props, transformData)
        let formData = new FormData()
        formData.append('parent_id', parentId)
        let files = props.files
        files.forEach(file => {
          formData.append(file.name, file)
        })
        for (let key in model) {
          if (key !== 'files') formData.append(key, model[key] || null)
        }
        this.$_executeApi('post', `${this.MODULE_URL}/upload`, formData)
          .finally(() => {
            this.documentFormloading = false
            this.closeDocumentDialogHandler()
            this.getBaseFolders()
          })
      } else this.$root.$emit('snackbar', { snackbar: true, color: 'error', text: this.$t('message.common.validationIssue') })
    },
    editMetaInDocument (item) {
      this.isShowAttachment = false
      this.uploadDocumentDialog = true
      this.propertyModel = this.$formatter.cloneVariable(item)
      let properties = this.propertyModel.properties
      let formModel = {}
      for (let i = 0; i < properties.length; i++) {
        this.dateFieldsForConversion.forEach(element => {
          if (element === properties[i].name && properties[i].value) {
            properties[i].value = this.$formatter.formatDate(properties[i].value, 'DD.MM.YYYYTHH:mm:ss', 'DD.MM.YYYY')
          }
        })
        if (properties[i].value && properties[i].value.lookupid) formModel[properties[i].name] = properties[i].value.lookupid
        else formModel[properties[i].name] = properties[i].value
      }
      this.propertyModel.properties = formModel
      let attachmentRefIndex = this.formProps.findIndex(x => x.model === 'files')
      if (attachmentRefIndex >= 0) this.formProps.splice(attachmentRefIndex, 1)
    },
    updateDocumentMeta () {
      this.documentFormloading = true
      let parentId = (this.active && this.active[0]) ? this.active[0].id : null
      this.propertyModel.parent_id = parentId
      let model = this.$formatter.cloneVariable(this.propertyModel.properties)
      model = Object.assign({ ...model }, { parent_id: parentId })
      let transformData = { date: { list: this.dateFieldsForConversion, from: 'DD.MM.YYYY', to: 'MM.DD.YYYY' } }
      model = this.$_formatModel(model, transformData)
      this.$_executeApi('put', `${this.MODULE_URL}/update_doc_meta_data/${this.propertyModel.id}`, model)
        .finally(() => {
          this.documentFormloading = false
          this.closeDocumentDialogHandler()
          this.getBaseFolders()
        })
    },
    sharepointSearch (term) {
      let data = { type: 'F_HSE_LIST', data: { filter: { search: term } } }
      this.$store.commit('rememberFilter', data)
      if (term) {
        let path = ''
        if (this.selectedNode) path = this.selectedNode
        else path = this.foldersList[0].webUrl
        this.loadingBase = true
        this.$_executeApi('get', `${this.MODULE_URL}/search?term=${term}&&path=${path}`).then(response => {
          this.searchResultArray = response.data
          this.hideTreeViewActions = true
        }).finally(() => {
          this.loadingBase = false
        })
      }
    },
    closeDocumentDialogHandler () {
      this.uploadDocumentDialog = false
      this.$refs.documentReference.$refs.validateForm.reset()
    },
    deleteHandler (id) {
      let payload = { url: `${this.MODULE_URL}/delete/${id}`, module: this.MODULE_URL, isSingle: true }
      this.$store.commit('showDeleteDialog', payload)
    },
    autoFocusField () {
      requestAnimationFrame(() => {
        if (this.$refs.folderReference.$refs.autoFocus) this.$refs.folderReference.$refs.autoFocus[0].focus()
      })
    },
    navigateToOD (url) {
      window.open(url, '_blank')
    },
    mimeTypeOfDocument (type) {
      let image = ''
      switch (type) {
        case 'image/png':
        case 'image/jpeg':
        case 'image/gif':
        case 'image/svg+xml':
          image = { icon: 'mdi-file-image', color: null }
          break
        case 'application/pdf':
          image = { icon: 'mdi-file-pdf-box', color: 'error' }
          break
        case 'text/html':
          image = { icon: 'mdi-language-html5', color: '#f16428' }
          break
        case 'video/mp4':
          image = { icon: 'mdi-file-video', color: null }
          break
        case 'audio/mpeg':
          image = { icon: 'mdi-audiobook', color: null }
          break
        case 'application/msword':
        case 'application/vnd.openxmlformats-officedocument.wordprocessingml.document':
        case 'application/vnd.openxmlformats-officedocument.wordprocessingml.template':
          image = { icon: 'mdi-file-word', color: 'info' }
          break
        case 'application/vnd.ms-excel':
        case 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet':
        case 'application/vnd.openxmlformats-officedocument.spreadsheetml.template':
          image = { icon: 'mdi-file-excel', color: 'green' }
          break
        case 'application/vnd.ms-powerpoint':
        case 'application/vnd.openxmlformats-officedocument.presentationml.presentation':
        case 'application/vnd.openxmlformats-officedocument.presentationml.template':
        case 'application/vnd.openxmlformats-officedocument.presentationml.slideshow':
          image = { icon: 'mdi-file-powerpoint', color: 'error' }
          break
        case 'application/x-rar-compressed':
        case 'application/octet-stream':
        case 'application/zip':
        case 'application/x-zip-compressed':
        case 'multipart/x-zip':
          image = { icon: 'mdi-zip-box', color: null }
          break
        default:
          image = { icon: 'mdi-file-cloud', color: null }
          break
      }
      return image
    },
    getTreeHight () {
      this.treeHight = `${window.innerHeight - 200}px`
    }
  },
  beforeDestroy () {
    this.$eventBus.$off('deleteSuccess')
  }
}
</script>
